import fs from 'node:fs'
import path from 'node:path'
import type { BetterstartConfig } from '@cli-types/core-engine/config.js'
import { CONFIG_FILE_NAME } from '@cli-constants/paths.js'
import { serializeConfig } from './serialize-config.js'

export function writeConfigFile(cwd: string, config: BetterstartConfig): void {
  fs.writeFileSync(path.join(cwd, CONFIG_FILE_NAME), serializeConfig(config), 'utf-8')
}
